import { Component, cloneElement, Children, ReactElement } from 'react'
import { connect } from 'react-redux'
import { State } from 'interfaces/state'
import * as styles from 'styles/atoms/balloons/BalloonWrapper.css'
import * as cn from 'classnames'
import { BalloonArrowDirection } from 'components/atoms/balloons/Balloon'
import { createBalloonArrowDirectionSelector } from 'selectors/globalSelectors'

type BalloonWrapperStateProps = {
  arrowDirection: BalloonArrowDirection
}

type BalloonWrapperOwnProps = {
  arrowDirection?: BalloonArrowDirection
}

type BalloonWrapperProps = BalloonWrapperStateProps & BalloonWrapperOwnProps

class BalloonWrapperComponent extends Component<BalloonWrapperProps> {
  render () {
    const { arrowDirection, children } = this.props

    const balloonWrapperClass = cn(styles.balloonWrapper, {
      [styles.leftArrow]: arrowDirection === 'left',
      [styles.downArrow]: arrowDirection === 'down',
    })

    const child = cloneElement(Children.only(children) as ReactElement, { arrowDirection })

    return (
      <div className={ balloonWrapperClass }>
        { child }
      </div>
    )
  }
}

const mapStateToProps = (state: State, ownProps: BalloonWrapperOwnProps) => ({
  arrowDirection: ownProps.arrowDirection || createBalloonArrowDirectionSelector('w768')(state),
})

const BalloonWrapper = connect<BalloonWrapperStateProps, {}, BalloonWrapperOwnProps>(mapStateToProps)(BalloonWrapperComponent)

export default BalloonWrapper
